import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=5c21ec3e"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"
import style0 from "./slide.vue?vue&type=style&index=0&id=5c21ec3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports